"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borghetto-d-arroscia": {
    "39661d93": [{
      "hkey": "c23da6e6",
      "slug": "borghetto-d-arroscia",
      "name": "Borghetto d'Arroscia",
      "primary": true,
      "skipSearch": false
    }],
    "cornari": [{
      "hkey": "c23da6e6",
      "slug": "borghetto-d-arroscia",
      "name": "Borghetto d'Arroscia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a823e740": [{
      "hkey": "734b7212",
      "slug": "gazzo-vigna",
      "name": "Gazzo-Vigna",
      "primary": true,
      "skipSearch": false
    }],
    "gazzo": [{
      "hkey": "734b7212",
      "slug": "gazzo-vigna",
      "name": "Gazzo-Vigna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;